import { COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO, TEXTOS_DESCARGA_SUPER_EJECUTIVO } from '../super-ejecutivo.constants';
import { IGraficaSuperEjecutivo, ITablaExcelSuperEjecutivo } from '../super-ejecutivo.interface';

/**
 * El Excel de una gráfica del Super Ejecutivo. Sale de la gráfica ya preparada (`prepararGraficaSuperEjecutivo`): el
 * archivo lleva lo mismo que se ve, con su orden y su "Otros". El nombre, la imagen y el archivo los arma
 * `super-ejecutivo-descarga.util.ts`, igual que para las tablas.
 */

/** Encabezado y tabla de cifras del Excel de una gráfica ya preparada para dibujarse. */
export function tablaExcelGraficaSuperEjecutivo(grafica: IGraficaSuperEjecutivo): ITablaExcelSuperEjecutivo {
  const encabezado = [
    grafica.titulo,
    ...(grafica.unidad ? [TEXTOS_DESCARGA_SUPER_EJECUTIVO.UNIDAD.replace('{unidad}', grafica.unidad)] : []),
    ...(grafica.nota ? [grafica.nota] : []),
  ];

  switch (grafica.tipo) {
    case 'mapaCalor':
      return {
        encabezado,
        columnas: ['', ...grafica.columnas],
        filas: grafica.filas.map((fila, i) => [fila, ...grafica.valores[i]]),
      };
    case 'progreso': {
      const columnas = [
        COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.VALOR,
        COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.TOTAL,
        COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.PORCENTAJE,
      ];

      return {
        encabezado,
        columnas,
        filas: [[grafica.valor, grafica.total, grafica.valor / grafica.total]],
        columnaPorcentaje: columnas.indexOf(COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.PORCENTAJE),
      };
    }
    case 'cifras':
      return {
        encabezado,
        columnas: [
          COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.ETIQUETA,
          COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.VALOR,
          COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.UNIDAD,
          COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.DETALLE,
        ],
        // Como en pantalla: la cifra sin unidad propia usa la de la gráfica.
        filas: grafica.cifras.map((c) => [c.etiqueta, c.valor, c.unidad ?? grafica.unidad ?? '', c.detalle ?? '']),
      };
    case 'dispersion':
      return {
        encabezado,
        columnas: [COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.ETIQUETA, grafica.ejeX, grafica.ejeY],
        filas: grafica.puntos.map((p) => [p.etiqueta, p.x, p.y]),
      };
    default:
      return {
        encabezado,
        columnas: [COLUMNAS_EXCEL_GRAFICA_SUPER_EJECUTIVO.CATEGORIA, ...grafica.series.map((s) => s.nombre)],
        filas: grafica.categorias.map((categoria, i) => [categoria, ...grafica.series.map((s) => s.valores[i])]),
      };
  }
}
